<template>
<div class="chapter">
<div class="inner_page">
<div id="a12_text">
<p class="text">Diagrams in Text</p>
<p class="text1">A. Compass, Blue Pendant, and 9 Pendant turns</p>
<p class="text1">B. The 5th Battle Squadron’s turn to starboard on the run to the north</p>
<p class="text1">C. Deployment on the starboard wing</p>
<p class="text1">D. Scheer’s alternative routes home</p>
<p class="text1">E. Sketch showing handing room in a British ship</p>
<a id="page_xxvi">
</a></div><a id="page_xxvi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 12_text.vue?656a842c